import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      arr: [], 
      loading: true,
      date: ""
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.fetchSreenData();
      console.log("Refresh Data")
    },10000)
 }

  componentWillUnmount() {
    clearInterval(this.timer);
  }


  render() {
    console.log(this.state)
    return (
      <div className="diplaycontainer">
         <div className="displaybox">
         <Row><Col md="12"><h2 className="big">{this.state.date}</h2></Col>
          </Row> 
         <Row>
           <Col md="2"><h2 className="big1">Frächter</h2></Col>
           <Col md="2" ><h2 className="big1">Referenz</h2></Col>
           <Col md="1" ><h2 className="big1">Kommission</h2></Col>
           <Col md="2" ><h2 className="big1">Lagerort</h2></Col>
           <Col md="1" ><h2 className="big1">Pal. Anzahl</h2></Col>
           <Col md="2" ><h2 className="big1">Kennzeichen</h2></Col>
           <Col md="1" ><h2 className="big1">Ladereihenfolge</h2></Col>
         </Row>
         
         
         {this.state.arr.map((item, index) => (
          <>
         <Row key={index}>
           <Col md="2"><h2 className="big">{item.freighter}</h2></Col>
           <Col md="2" ><h2 className="big">{item.reference}</h2></Col>
           <Col md="1" ><h2 className="big">{item.commission}</h2></Col>
           <Col md="2" ><h2 className="big">{item.stockPlace}</h2></Col>
           <Col md="1" ><h2 className="big">{item.quantity}</h2></Col>
           <Col md="2" ><h2 className="big">{item.licensePlate}</h2></Col>
           <Col md="1" ><h2 className="big">{item.loadingOrder}</h2></Col>
         </Row> 
         <hr />
         </>
         ))}
            
         </div>
      </div>
    );
  }

  async fetchSreenData() {
    const response = await fetch('screendata');
    const data = await response.json();
    this.setState({date: data.date, arr: data.data, loading: false });
  }

}
